export default {
  questions: {
    openConversational: {
      openEndPlaceholder: "Voer asseblief jou teks hier in",
      conversationalPlaceholder: "Voer asseblief jou antwoord hier in",
      conversationClosed: "Gesprek gesluit.",
      conversationalDisclaimer: "Opvolgvrae sal deur AI gegenereer word op grond van jou antwoorde."
    },
    openText: {
      openEndPlaceholder: "Voer asseblief jou teks hier in"
    },
    multiText: {
      fieldPlaceholder: 'Antwoord {number}',
      instruction: 'Tik ten minste {count} antwoord hieronder, een per teksblokkie | Tik ten minste {count} antwoorde hieronder, een per teksblokkie',
      instructionWithoutMinimum: 'Tik jou antwoorde hieronder, een per teksblokkie',
      minimumEntries: 'Voer asseblief ten minste {count} antwoord in om voort te gaan. | Voer asseblief ten minste {count} antwoorde in om voort te gaan.',
      unaidedBrandAwareness: {
        fieldPlaceholder: 'Handelsmerk {number}',
        minimumEntries: 'Voer asseblief ten minste {count} handelsmerk in om voort te gaan. | Voer asseblief ten minste {count} handelsmerke in om voort te gaan.'
      }
    },
    multiselect: {
      caption: "Kies alle toepaslike opsies"
    },
    rankOrder: {
      enterRankOrder: "Voer rangorde in",
      placeholder: "Sleep jou keuses hierheen om te rangskik"
    },
    openNumeric: {
      label: "Oop Numeries"
    },
    complete: {
      message: "Dankie dat jy die opname voltooi het."
    },
    openVideo: {
      warning: "Neem asseblief 'n video op voordat u voortgaan.",
      uploadStatusUploading: "Wag asseblief totdat ons jou video verwerk het voordat jy voortgaan...",
      uploadStatusSuccess: "Oplaai suksesvol, jy kan voortgaan.",
      uploadStatusError: "Oplaai nie voltooi nie, probeer asseblief weer."
    }
  },
  errors: {
    node: {
      text_invalid_email: "Voer asseblief 'n geldige e-posadres in",
      text_invalid_phone: "Voer asseblief 'n geldige foonnommer in",
      text_invalid_us_zip: "Voer asseblief 'n geldige Amerikaanse poskode (ZIP) in",
      text_invalid_ca_postal: "Voer asseblief 'n geldige Kanadese poskode in",
      text_invalid_uk_postal: "Voer asseblief 'n geldige VK-poskode in",
      text_invalid_custom: "Voer asseblief 'n geldige {fieldName} in",
      text_min_chars: "Voer asseblief minstens {min} karakters in",
      text_max_chars: "Voer asseblief nie meer as {max} karakters nie",
      text_alpha_not_allowed: "Slegs syfers word toegelaat",
      text_numeric_not_allowed: "Slegs letters word toegelaat"
    },
    external: {
      invalid: 'Die antwoord op hierdie vraag is nie geldig nie.',
      required: 'Hierdie vraag moet beantwoord word.',
      singlechoice_required: 'Kies asseblief ’n opsie voordat u voortgaan.',
      numeric_required: 'Kies asseblief ’n gradering voordat u voortgaan.',
      text_required: 'Voer asseblief ’n antwoord in voordat u voortgaan.',
      bigtext_required: 'Voer asseblief ’n antwoord in voordat u voortgaan.',
      singlechoiceother_incomplete: 'Voer asseblief ’n antwoord in voordat u voortgaan.',
      multiselectother_incomplete: 'Voer asseblief ’n antwoord in voordat u voortgaan.',
      numeric_invalid: 'Voer asseblief ’n geldige nommer in voordat u voortgaan.',
      radiogrid_required: 'Kies asseblief ’n opsie vir elke ry voordat u voortgaan.',
      incomplete: 'Maak hierdie vraag klaar voordat u verder gaan.',
      multiselect_min: 'Kies asseblief ten minste {value} opsies voordat u voortgaan.',
      multiselect_max: 'Kies asseblief nie meer as {value} opsies voordat u voortgaan nie.',
      multiselectother_min: 'Kies asseblief ten minste {value} opsies voordat u voortgaan.',
      multiselectother_max: 'Kies asseblief nie meer as {value} opsies voordat u voortgaan nie.',
      multiselectgrid_min: 'Kies asseblief ten minste {value} opsies vir elke ry voordat u voortgaan.',
      multiselectgrid_max: 'Kies asseblief nie meer as {value} opsies vir elke ry voordat u voortgaan nie.',
      rankorder_min: 'Rangskik asseblief ten minste {value} items voordat u voortgaan.',
      rankorder_max: 'Rangskik asseblief nie meer as {value} items voordat u voortgaan nie.'
    }
  }
}
